import { LocalizedLanguageFormData } from '../common/localizedLanguage';
import { localizedStringToFormData } from '../common/localizedString';
import { MealType } from '../mealType';
import { MealItemDetailsData } from './mealItemDetailsData';

export interface FileWithPreview extends File {
  preview?: string;
}

export interface MealItemFormData {
  id?: string;
  names: LocalizedLanguageFormData;
  descriptions?: LocalizedLanguageFormData;
  price: number;
  picture?: FileWithPreview | null;
  pictureUrl?: string;
  kitchenId: string;
  mealType: MealType;
  isAvailable: boolean;
  taxRateId?: string;
}

export const toMealItemFormData = (
  mealItem: MealItemDetailsData
): MealItemFormData => ({
  id: mealItem.id,
  names: localizedStringToFormData(mealItem.name),
  descriptions: mealItem.description
    ? localizedStringToFormData(mealItem.description)
    : undefined,
  price: mealItem.price,
  pictureUrl: mealItem.pictureUrl,
  kitchenId: mealItem.kitchen.id,
  mealType: mealItem.mealType,
  isAvailable: mealItem.isAvailable,
  taxRateId: mealItem.taxRateId,
});
